import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Typography,
} from '@xbotvn/mui';
import PropTypes from 'prop-types';
import React from 'react';

export default function YouTubeStudioWarning({
  open,
  studioUrlDialog = {
    originalUrl: '',
    convertedUrl: '',
  },
  onConvert,
  onClose,
}) {
  if (!open) return null;

  const { originalUrl, convertedUrl } = studioUrlDialog;
  return (
    <Dialog open maxWidth="sm" fullWidth>
      <DialogTitle onClose={onClose}>Cảnh báo đường link</DialogTitle>
      <DialogContent>
        <Typography>
          Đường link này không phải đường link xem trực tiếp.
        </Typography>
        <Typography sx={{ mt: 1 }}>
          <strong>Link gốc:</strong>
          <br />
          {originalUrl}
        </Typography>
        <Typography sx={{ mt: 1 }}>
          <strong>Link xem trực tiếp:</strong>
          <br />
          {convertedUrl}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          color="success"
          onClick={() => {
            onConvert(convertedUrl);
            onClose();
          }}
        >
          Chuyển tự động
        </Button>
      </DialogActions>
    </Dialog>
  );
}

YouTubeStudioWarning.propTypes = {
  open: PropTypes.bool.isRequired,
  studioUrlDialog: PropTypes.shape({
    originalUrl: PropTypes.string,
    convertedUrl: PropTypes.string,
  }),
  onConvert: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
